import DimensionsSVG from "@/public/site-assets/svg/dimensions.svg";
import BrushSVG from "@/public/site-assets/svg/green-brush.svg";
import TubeSVG from "@/public/site-assets/svg/red-tube.svg";
import ScissorSVG from "@/public/site-assets/svg/scissors.svg";
import StarSVG from "@/public/site-assets/svg/star.svg";
import StationarySVG from "@/public/site-assets/svg/stationary.svg";
import TrophySVG from "@/public/site-assets/svg/trophy.svg";
import clsx from "classnames";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import Buttons from "ui/Buttons/component";
import styles from "./styles.module.scss";
import FooterWave2Icon from "/public/site-assets/svg/footer-wave-2.svg";

export const SimpleContent = ({
  className,
  content,
  lead_content,
  buttons,
  showIcons,
  paddingTop,
  paddingBottom,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust threshold as needed, make it smaller for more sensitive detection
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(sectionRef.current);

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
      // setIsVisible(!mobileDevice); // Hide motion on mobile devices
    };

    handleResize(); // Call initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <section
      ref={sectionRef}
      className={clsx(
        className,
        !showTopWave && (paddingTop || "pt-5"),
        !showWave && (paddingBottom || "pb-5"),
        showTopWave && "pt-0",
        showWave && "pb-0",
        styles.root,
      )}
    >
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <Container className="position-relative">
        {showIcons && (
          <>
            <motion.span
              className="floating-icon"
              initial={{ opacity: 0 }}
              animate={isVisible ? { opacity: 1 } : {}}
              transition={{ duration: 1.5, delay: 1.3 }}
            >
              <TrophySVG />
            </motion.span>
            <motion.span
              className="floating-icon"
              initial={{ opacity: 0 }}
              animate={isVisible ? { opacity: 1 } : {}}
              transition={{ duration: 1.5, delay: 1 }}
            >
              <StationarySVG />
            </motion.span>
            <motion.span
              className="floating-icon"
              initial={{ opacity: 0 }}
              animate={isVisible ? { opacity: 1 } : {}}
              transition={{ duration: 1.5, delay: 0.3 }}
            >
              <BrushSVG />
            </motion.span>
            <motion.span
              className="floating-icon"
              initial={{ opacity: 0 }}
              animate={isVisible ? { opacity: 1 } : {}}
              transition={{ duration: 1.5, delay: 2 }}
            >
              <TubeSVG />
            </motion.span>
            <motion.span
              className="floating-icon"
              initial={{ opacity: 0 }}
              animate={isVisible ? { opacity: 1 } : {}}
              transition={{ duration: 1.5, delay: 2.3 }}
            >
              <StarSVG />
            </motion.span>
            <motion.span
              className="floating-icon"
              initial={{ opacity: 0 }}
              animate={isVisible ? { opacity: 1 } : {}}
              transition={{ duration: 1.5, delay: 3 }}
            >
              <ScissorSVG />
            </motion.span>
            <motion.span
              className="floating-icon"
              initial={{ opacity: 0 }}
              animate={isVisible ? { opacity: 1 } : {}}
              transition={{ duration: 1.5, delay: 3.3 }}
            >
              <DimensionsSVG />
            </motion.span>
          </>
        )}
        <div className="wrapper position-relative">
          {lead_content && (
            <div className={`lead-content`} dangerouslySetInnerHTML={{ __html: lead_content }} />
          )}
          {content && <div className={`content`} dangerouslySetInnerHTML={{ __html: content }} />}

          {buttons && <Buttons buttons={buttons} className="d-flex justify-content-center" />}
        </div>
      </Container>
      {showWave && (
        <div
          className={clsx(
            "footer",
            waveDirection === "down" && "rotate",
            waveColor,
            waveBackground,
          )}
          style={{ marginTop: "-1px" }}
        >
          <FooterWave2Icon />
        </div>
      )}
    </section>
  );
};

export default SimpleContent;
